import React from 'react';
import { connect } from 'react-redux';
import { RootReducerState } from 'redux/reducers';
import { ViewMounter } from '../view_mounter';
import { SecureRoute } from '../shared/secure_route';
import { Panel, PanelPresets, UserPermissionsIds } from '../../utility/enumerations';

function PeopleSearchContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/people/search/fromMultiple"
        pathPermissionId={UserPermissionsIds.PeopleSearch}
        render={(props) => ViewMounter(props, {
          viewPath: 'search/people_search',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/people/search"
        pathPermissionId={UserPermissionsIds.PeopleSearch}
        render={(props) => ViewMounter(props, {
          viewPath: 'search/people_search',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/people/search/results"
        pathPermissionId={undefined} // TO DO Change all the undefined to
        render={(props) => ViewMounter(props, [{
          viewPath: 'search/people_search',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'search/results/multi_result_card_list',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/people/search/results/caregiver/:id"
        pathPermissionId={UserPermissionsIds.ReadCaregiver} // TO DO Missing Permission Id for cargivers
        render={(props) => ViewMounter(props, [{
          viewPath: props?.location?.search?.indexOf('fromMultiple') > -1
            ? 'search/results/multi_result_card_list' : 'search/people_search',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          focusView: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        },
        {
          viewPath: 'caregiver/caregiver_profile',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/people/search/results/transporter"
        pathPermissionId={UserPermissionsIds.SearchTransporterByNameDob}
        render={(props) => ViewMounter(props, [{
          viewPath: 'search/people_search',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          focusView: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        },
        {
          viewPath: 'search/results/transporter_search_result',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: false,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
    </div>
  );
}

function mapStateToProps(state: RootReducerState) {
  return {
    userTypeId: state.security.user.userTypeId,
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleSearchContainerScreen);
